import React, { Component, Fragment } from "react";
import * as R from "ramda";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import Api from "../../../../Services/Api";
import { mapToDDL } from "../../../common/mapper";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";

class MasterPackageH2Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllSelected: false,
      isSpecificSelected: false,
      dataCabang: [],
      dataVariant: [],
      dataSegment: [],
      segment: null,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
    this.fetchDataVariant();
    this.fetchDataSegment();
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (
  //     prevProps.controls?.allCabang?.value !==
  //     this.props.controls?.allCabang?.value
  //   ) {
  //     this.setState((prevState) => ({
  //       ...prevState,
  //       isAllSelected: this.props.controls?.allCabang?.value,
  //       isSpecificSelected: !this.props.controls?.allCabang?.value,
  //     }));
  //   }
  // }

  componentDidUpdate(prevProps) {
    if (
      prevProps.controls?.allCabang?.value !==
      this.props.controls?.allCabang?.value
    ) {
      this.setState({
        isAllSelected: this.props.controls?.allCabang?.value,
        isSpecificSelected: !this.props.controls?.allCabang?.value,
      });
    }

    if (
      prevProps.controls?.kodeVariant?.value !==
        this.props.controls?.kodeVariant?.value &&
      this.props.activeTab === "Job"
    ) {
      if (typeof this.props.onVariantChange === "function") {
        this.props.onVariantChange(this.props.controls?.kodeVariant?.value);
      }
    }
  }

  handleSelectedBranch = (e, type) => {
    const isChecked = e.target.checked;
    const { isAllSelected, isSpecificSelected } = this.state;

    if (
      (type === "all" && isAllSelected) ||
      (type === "specific" && isSpecificSelected)
    ) {
      return;
    }

    const newState = {
      isAllSelected: type === "all",
      isSpecificSelected: type === "specific",
    };

    this.setState(newState);

    if (type === "all") {
      this.props.setValue("allCabang", true);
      this.props.setValue("kodeCabang", []);
    } else {
      const selectedCabang = this.props.controls?.kodeCabang?.value || [];
      this.props.setValue("allCabang", false);
      this.props.setValue("kodeCabang", selectedCabang);
    }
  };

  // fetchDataCabang = async () => {
  //   try {
  //     let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
  //     if (res.ok) {
  //       this.setState((prevValue) => ({
  //         ...prevValue,
  //         dataCabang: res.data.data,
  //       }));
  //     }
  //   } catch (error) {
  //     console.log("errors: ", error);
  //   }
  // };

  fetchDataCabang = async () => {
    try {
      const res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok && res.data?.data) {
        const allowedCabang =
          this.props.menuAccess?.map((data) => data.idRefObj) || [];

        const dataCabang = res.data.data.filter((item) =>
          allowedCabang.includes(item.kodeCabang)
        );

        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSegment = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSegmenPaging,
        menuName: "Master Package H23",
        setError: this.props.setError,
        args: {
          paramFilters: {},
          page: null,
          limit: null,
        },
      });
      if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        this.setState((prevState) => ({
          ...prevState,
          dataSegment: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataVariant = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataVariant: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleHasPeriod = (value) => {
    this.props.setValue("hasGracePeriod", value);
    if (value) {
      this.props.setValue("startDate", null);
      this.props.setValue("endDate", null);
      this.props.setValue("gracePeriod", null);
    }
  };

  handleChangeSegment = async (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleTambahVariantBySegment = async () => {
    try {
      const id = this.state.segment?.value;

      if (!id) return;

      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getVariantBySegmentId,
        menuName: "Master Package H23",
        setError: this.props.setError,
        args: contructQueryParam({ segment: id }),
      });

      if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        const variantList = response.data.data || [];

        const kodeVariants = variantList.map((item) => ({
          label: item.kodeVariant,
          value: item.kodeVariant,
        }));

        this.props.setValue("kodeVariant", kodeVariants);
      }
    } catch (error) {
      console.error("Error handleTambahVariantBySegment:", error);
    }
  };

  // handleClearVariant = () => {
  //   this.props.setValue("kodeVariant", []);
  // };

  handleClearVariant = () => {
    this.props.setValue("kodeVariant", []);

    if (typeof this.props.onVariantChange === "function") {
      this.props.onVariantChange([]);
    }

    if (typeof this.props.onClearVariant === "function") {
      this.props.onClearVariant();
    }
  };

  handleVariantChange = (value, { name }) => {
    const newValue = value || []; 
    const prevVariants = this.props.controls?.kodeVariant?.value || [];

    const removedVariants = prevVariants.filter(
      (v) => !newValue.some((s) => s.value === v.value)
    );

    let updatedJobs = this.state.jobs || [];
    removedVariants.forEach((rv) => {
      updatedJobs = updatedJobs.filter((job) => job.variantCode !== rv.value);
    });

    this.props.setValue(name, newValue);

    this.setState({
      selectedVariants: newValue,
      jobs: updatedJobs,
    });

    if (typeof this.props.onVariantChange === "function") {
      this.props.onVariantChange(newValue);
    }
  };

  render() {
    return (
      <Fragment>
        <div className="grid grid-2x gap-20px grid-mobile-none">
          <div id="grid-1">
            <SimpleInput
              id="input_text_packageID"
              name="packageId"
              label="Paket ID"
              mandatory
              readOnly
              errorMessage={this.props.errors?.packageId}
              value={this.props.controls?.packageId?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="select_options_packageName"
              name="packageName"
              label="Nama Paket"
              mandatory
              errorMessage={this.props.errors?.packageName}
              value={this.props.controls?.packageName?.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <div className="margin-bottom-30px">
              <div className="margin-5px">
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>
                    Cabang Berlaku<span style={{ color: "red" }}>*</span>
                  </h4>
                </div>
              </div>
              <div className="grid grid-2x grid-mobile-none gap-15px">
                <SimpleCheckBox
                  id="allCabang"
                  key="allCabang"
                  name="allCabang"
                  label="All"
                  checked={this.state.isAllSelected}
                  onChange={(e) => this.handleSelectedBranch(e, "all")}
                />
                <SimpleCheckBox
                  id="specific"
                  key="specific"
                  name="specific"
                  label="Specific"
                  checked={this.state.isSpecificSelected}
                  onChange={(e) => this.handleSelectedBranch(e, "specific")}
                />
              </div>
              {!this.state.isAllSelected &&
                !this.state.isSpecificSelected &&
                !R.isNil(this.props.errorListCabang) && (
                  <p className="txt-site txt-11 color-red margin-top-5px">
                    {this.props.errorListCabang}
                  </p>
                )}
            </div>

            {this.state.isSpecificSelected && (
              <SimpleDDL
                id="select_options_kodeCabang"
                name="kodeCabang"
                label="Cabang Berlaku"
                box="multiselect"
                mandatory={this.state.isSpecificSelected}
                options={this.state.dataCabang.map((item) =>
                  mapToDDL(item.namaDealer, item.kodeCabang)
                )}
                errorMessage={this.props.errorListCabang}
                value={this.props.controls?.kodeCabang?.value}
                onChange={(value, { name }) => this.props.setValue(name, value)}
                isDisabled={this.state.isAllSelected}
              />
            )}
          </div>
          <div id="grid-2">
            <FlexView
              vAlignContent="top"
              hAlignContent="left"
              style={{ gap: "10px" }}
            >
              <SimpleDDL
                id="select_options_segment"
                name="segment"
                label="Segment"
                box="search"
                isClearable
                containerclassname="margin-bottom-5px width width-270px"
                options={this.state.dataSegment.map((item) =>
                  mapToDDL(item.segmentName, item.id)
                )}
                value={this.state.segment}
                onChange={(value, { name }) =>
                  this.handleChangeSegment(name, value)
                }
              />
              <div style={{ marginTop: 22 }}>
                <SimpleButton
                  text="Tambahkan"
                  type="button"
                  onClick={() => this.handleTambahVariantBySegment()}
                />
              </div>
            </FlexView>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <SimpleDDL
                id="select_options_kodeVariant"
                name="kodeVariant"
                label="Kode Variant"
                box="multiselect"
                isClearable={false}
                mandatory
                styles={{ marginBottom: 5 }}
                options={this.state.dataVariant.map((item) =>
                  mapToDDL(item.kodeVariant, item.kodeVariant)
                )}
                errorMessage={this.props.errors.kodeVariant}
                value={this.props.controls?.kodeVariant?.value}
                // onChange={(value, { name }) => this.props.setValue(name, value)}
                // onChange={(value, { name }) => {
                //   this.props.setValue(name, value);
                //   if (typeof this.props.onVariantChange === "function") {
                //     this.props.onVariantChange(value);
                //   }
                // }}
                onChange={this.handleVariantChange}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: 10,
                  marginTop: "-15px",
                }}
              >
                <SimpleButton
                  text="Clear"
                  type="button"
                  onClick={() => this.handleClearVariant()}
                />
              </div>
            </div>

            <SimpleDate
              backdate
              label="Start Date"
              date={this.props.controls?.startDate?.value}
              disabled={this.props.controls?.hasGracePeriod?.value}
              mandatory={!this.props.controls?.hasGracePeriod?.value}
              errorMessage={this.props.errorStartDate}
              onChange={(value) =>
                this.props.setValue("startDate", M(value).format("DD-MM-YYYY"))
              }
            />
            <SimpleDate
              backdate
              label="End Date"
              date={this.props.controls?.endDate?.value}
              disabled={this.props.controls?.hasGracePeriod?.value}
              mandatory={!this.props.controls?.hasGracePeriod?.value}
              errorMessage={this.props.errorEndDate}
              onChange={(value) =>
                this.props.setValue("endDate", M(value).format("DD-MM-YYYY"))
              }
            />
            <div className="grid grid-2x grid-mobile-none gap-30px">
              <FlexView vAlignContent={"center"} style={{ gap: 10 }}>
                <SimpleInput
                  id="input_text_gracePeriod"
                  name="gracePeriod"
                  label="Grace Period"
                  box="onlyNumber"
                  mandatory={!this.props.controls?.hasGracePeriod?.value}
                  errorMessage={this.props.errorGracePeriod}
                  readOnly={Boolean(this.props.controls.hasGracePeriod?.value)}
                  value={this.props.controls.gracePeriod?.value}
                  onChange={({ target }) =>
                    this.props.setValue(target.name, target.value.slice(0, 3))
                  }
                />
                <div className="txt-15">
                  <span>Hari</span>
                </div>
              </FlexView>
              <SimpleCheckBox
                id="noPeriod"
                key="noPeriod"
                name="hasGracePeriod"
                label="No Period"
                checked={Boolean(this.props.controls.hasGracePeriod?.value)}
                onChange={(e) => this.handleHasPeriod(e.target.checked)}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MasterPackageH2Header;
